import styled from 'styled-components';

export const Notification = styled.div.attrs({
  'aria-live': 'assertive',
  className: 'validation-error',
})`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-base);
  padding: var(--spacing-large);
  border: var(--spacing-xsmall) solid var(--error-600);
  border-radius: var(--radius-large);
  font-size: var(--font-size-text-lg);
  font-weight: var(--font-weight-semibold);
  color: var(--error-600);

  & p {
    font-size: var(--font-size-text-lg);
    font-weight: var(--font-weight-semibold);
    color: var(--foreground-color);
  }

  & ul {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-small);
    margin-inline-start: var(--spacing-base);
  
    & li button {
      display: flex;
      align-items: flex-start;
      text-align: left;
      font-size: var(--font-size-text-md);
      font-weight: var(--font-weight-regular);
      color: var(--error-600);
      text-decoration-color: var(--error-600);
    }
  }
`;
